var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1501 -21 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 10.625  C 18 9.58984375  17.136160714285715 8.75  16.071428571428573 8.75  L 15.107142857142858 8.75  L 15.107142857142858 5.9375  C 15.107142857142858 2.6640625  12.366964285714287 0  9 0  C 5.633035714285715 0  2.8928571428571432 2.6640625  2.8928571428571432 5.9375  L 2.8928571428571432 8.75  L 1.9285714285714284 8.75  C 0.8638392857142858 8.75  0 9.58984375  0 10.625  L 0 18.125  C 0 19.16015625  0.8638392857142858 20  1.9285714285714284 20  L 16.071428571428573 20  C 17.136160714285715 20  18 19.16015625  18 18.125  L 18 10.625  Z M 11.892857142857142 5.9375  L 11.892857142857142 8.75  L 6.107142857142858 8.75  L 6.107142857142858 5.9375  C 6.107142857142858 4.38671875  7.404910714285714 3.125  9 3.125  C 10.595089285714286 3.125  11.892857142857142 4.38671875  11.892857142857142 5.9375  Z ",
    fillRule: "nonzero",
    fill: "#3cd27d",
    stroke: "none",
    transform: "matrix(1 0 0 1 1501 21 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.512bbfe64ad8ee6fe759552e67da0641.svg";
export { ForwardRef as ReactComponent };